import React from 'react';
import Skeleton from 'react-loading-skeleton';

const CustomTableSkeleton: React.FC<{ count?: number; hasTabs?: boolean }> = ({
  count = 40,
  hasTabs = false,
}) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: '5px',
        overflow: 'clip',
        height: hasTabs ? 'calc(100% - 50px)' : 'calc(100%)',
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          style={{
            height: 38,
            width: '100%',
            borderRadius: 4,
            backgroundColor: '#f8f8f8',
          }}
        />
      ))}
    </div>
  );
};

export { CustomTableSkeleton };
